export default __webpack_public_path__ + "static/media/comments.d862da2d.png";